import { P } from "../../../../../../AbstractElements";
import CommonFileUpload from "../../../../../Common/CommonFileUpload";

const ProductGallery = () => {
  return (
    <div className="product-upload">
      <P>Product Gallery</P>
      <CommonFileUpload multiple />
    </div>
  );
};

export default ProductGallery;
